/**
 * Page heading, styled after `ProductListHeader`
 * (src/screens/lcaProduct/productList/components/ProductListHeader.tsx).
 * Unlike Product/Ingredient, this deliberately has no "+ Register" action —
 * the prototype's "+ Register New Supplier" button and create flow are
 * explicitly out of scope for this release.
 */
const SupplierListHeader = () => {
  return (
    <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-gap-4">
      <div>
        <h1 className="tw-font-display tw-text-2xl tw-font-bold tw-text-foreground">Suppliers</h1>
        <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
          Registered suppliers, their contact people and where they operate from
        </p>
      </div>
    </div>
  );
};

export default SupplierListHeader;
